import React, { useRef } from 'react';
import { CSSTransition as CSSTransitionLib } from 'react-transition-group';

/** Cast for React 19 type compatibility with react-transition-group. */
const CSSTransition = CSSTransitionLib as React.ComponentType<any>;

interface LoadingOverlayProps {
  active: boolean;
  children?: React.ReactNode;
  content?: React.ReactNode;
  disabled?: boolean;
}

const LoadingOverlay = ({
  active,
  children,
  content,
  disabled,
}: LoadingOverlayProps) => {
  const nodeRef = useRef(null);
  if (disabled) {
    return <>{children}</>;
  }
  return (
    <div className="yepcode-loading-overlay-root">
      {children}
      <CSSTransition
        nodeRef={nodeRef}
        in={active}
        timeout={200}
        unmountOnExit
        classNames="yepcode-loading-overlay"
      >
        <div
          ref={nodeRef}
          data-testid="overlay"
          className="yepcode-loading-overlay"
        >
          <div className="yepcode-loading-overlay-content-wrapper">
            <div
              data-testid="spinner"
              className="yepcode-loading-overlay-spinner"
            >
              <svg viewBox="25 25 50 50">
                <circle
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                />
              </svg>
            </div>
            {content && (
              <p
                data-testid="content"
                className="yepcode-loading-overlay-content"
              >
                {content}
              </p>
            )}
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default LoadingOverlay;
